import styled from 'styled-components';

export const Styles = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0.3rem;

  .toggle {
    position: relative;
    color: #444;
    border: solid 1px #888;
    font-size: 0.8rem;
    cursor: pointer;
    min-width: 350px;
    text-align: center;

    & > span {
      padding: 0px 2px;
    }

    &:hover {
      background-color: #888;
    }

    &.selected {
      background-color: #28a745;
      border-color: #28a745;
    }

    &:hover,
    &.selected {
      & > span {
        color: #fff;
      }
    }
  }

  .list-dropdown {
    position: absolute;
    width: 100%;
    z-index: 8; // react-stockchart has z-index 6
    background-color: #fff;
    padding: 0.5rem;
    border: solid 1px #888;
    box-shadow: 0px 2px 3px 0px #ccc;

    .LoadingImage {
      position: absolute;
      right: 0.1rem;
      top: 0.1rem;
    }

    .user-list-header {
      font-weight: bold;
      font-size: 0.8rem;
      padding: 0 1.5rem;
    }

    .user-list-section {
      max-height: 30vh;
      overflow-y: auto;
      border-bottom: solid 1px #888;
      margin-bottom: 1rem;
    }

    .user-list-item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0px 0.5rem;

      .user-name-container {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        margin-right: 0.5rem;
        .user-name {
          display: inline-block;
          overflow: hidden;
          max-width: 25ch;
          text-overflow: ellipsis;
        }
      }

      .last-update-span {
        border-radius: 2px;
        background-color: #888;
        color: #fff;
        padding: 0px 0.5rem;
        font-size: 0.7rem;
      }

      &.align-left {
        justify-content: left;
      }

      &:hover,
      &.selected {
        background-color: #888;
        color: #fff;
        .last-update-span {
          color: #333;
          background-color: #ccc;
        }
      }
    }
  }

  .disabled {
    color: #888;
    font-size: 0.7rem;
  }
`;
